export var CHEVRON_RIGHT_ICON = 'chevron-right';
export var ANGLE_DOWN_ICON = 'angle-down';
export var DROPDOWN_DIRECTION_LEFT = 'left';
export var DROPDOWN_DIRECTION_RIGHT = 'right';
export var DROPDOWN_DIRECTION_LEFT_CLASS = 'dropdown-direction-left';
export var DROPDOWN_DIRECTION_OPTIONS = [DROPDOWN_DIRECTION_LEFT, DROPDOWN_DIRECTION_RIGHT];
export var SLIDE_ANIMATION_DURATION = 500;